<style lang="stylus" scoped>
.selected-square
	width 32px
	height 32px

.picker
	position absolute
</style>


<template lang="pug">
div.ColorPicker
	div.selected-square(v-bind:style="{backgroundColor:value.hex}" v-on:click="click")
	div.picker(v-show='visible')
		compact-picker(v-model="color")
</template>


<script>
import { Compact } from 'vue-color'

export default {
	props: ['value'],
	components:{
		'compact-picker': Compact
	},
	mounted: function () {
	},
	data: function () {
		return{
			color: this.value,
			visible: false,
		}
	},
	methods: {
		click(){
			this.visible = true
		}
	},
	watch:{
		color: function(n, o){
			this.$emit('input', n)
			this.visible = false
		}
	}
}
</script>
